import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { id: 'benefits-section', label: 'Benefits' },
    { id: 'expansion-section', label: 'Roadmap' },
    { id: 'testimonials-section', label: 'Testimonials' },
    { id: 'hero', label: 'Early Access' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const elementPosition = element?.getBoundingClientRect()?.top;
      const offsetPosition = elementPosition + window.pageYOffset - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const handleJoinNetwork = () => {
    scrollToSection('hero');
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ?
        'bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm' :
        'bg-white'}`
        }>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo Section */}
            <div className="flex-shrink-0">
              <div className="flex items-center -ml-6">
                {/* Unified ProConnect Logo */}
                <img
                  src="/assets/images/Untitled_design_2_-1761185899832.png"
                  alt="ProConnect unified logo with blue house icon, orange clock element, and PROCONNECT text with EMERGENCY HOME SERVICES tagline"
                  className="h-12 w-auto object-contain"
                  style={{ height: '3.465rem' }}
                />
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              {navigationItems?.map((item) =>
              <button
                key={item?.id}
                onClick={() => scrollToSection(item?.id)}
                className="font-medium text-sm transition-colors duration-200 text-gray-700 hover:text-blue-600">

                  {item?.label}
                </button>
              )}
            </nav>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center">
              <Button
                onClick={handleJoinNetwork}
                className="px-6 py-2 rounded-lg font-medium text-sm transition-colors duration-200"
                style={{
                  backgroundColor: '#F97316',
                  color: 'white'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#E35C0C'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#F97316'}>

                Join Network
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 rounded-md transition-colors duration-200 text-gray-700 hover:text-blue-600 hover:bg-gray-100">

                <Icon
                  name={isMobileMenuOpen ? "X" : "Menu"}
                  size={24} />

              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden bg-white border-b border-gray-200 shadow-lg">
            <div className="px-4 py-2 space-y-1">
              {navigationItems?.map((item) =>
            <button
              key={item?.id}
              onClick={() => scrollToSection(item?.id)}
              className="block w-full text-left px-3 py-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-50 font-medium text-sm transition-colors duration-200">

                  {item?.label}
                </button>
            )}
              <div className="pt-2 pb-1">
                <Button
                onClick={handleJoinNetwork}
                className="w-full px-6 py-2 rounded-lg font-medium text-sm transition-colors duration-200"
                style={{
                  backgroundColor: '#F97316',
                  color: 'white'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#E35C0C'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#F97316'}>

                  Join Network
                </Button>
              </div>
            </div>
          </div>
        }
      </header>
      {/* Spacer to prevent content overlap */}
      <div className="h-16"></div>
    </>);

};

export default Header;